import type { CSSProperties } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';
import { Overlay } from '../../../components/Overlay/Overlay';
import { Tooltip } from '../../../components/Tooltip/Tooltip';
import { analytics } from '../../../services/analytics';
import { useStores } from '../../../stores/useStores';
import tutorialStyles from '../LoyaltyProgramTutorial.module.scss';

import styles from './TutorialVipClubStatus.module.scss';

const TutorialVipClubStatus = ({
  setPopperElement,
  tooltipStyles,
  handleClick,
}: {
  setPopperElement: (el: HTMLElement | null) => void;
  tooltipStyles: CSSProperties;
  handleClick: () => void;
}) => {
  const { loyaltyProgramStore } = useStores();
  const { t } = useTranslation();

  const onClickMoreInfo = () => {
    if (!loyaltyProgramStore.userLoyalty?.currentTier) return;

    void analytics.sendEvent('loyalty_tutorial', {
      loyalty_club: loyaltyProgramStore.userLoyalty.currentTier.key,
      loyalty_percentage: loyaltyProgramStore.loyaltyPointsPercentages,
      tutorial_button_ind: 'more_info',
    });

    handleClick();
  };

  return (
    <Overlay
      backdropClassName={tutorialStyles.overlayBackdrop}
      className={classNames(tutorialStyles.overlay, styles.overlayClassName)}
    >
      <Tooltip showArrow setTooltipRef={setPopperElement} tooltipPositionStyle={tooltipStyles}>
        <p className={styles.textLine}>
          <span>
            {t('loyaltyProgramTutorial.checkYour')} <b>{t('loyalty.vipClub')}</b>{' '}
            {t('loyaltyProgramTutorial.statusAnd')}
          </span>
        </p>
        <p className={styles.textLine}>
          <span>{t('loyaltyProgramTutorial.progressToNextLevel')}</span>
        </p>
        <Button
          btnType="main"
          className={styles.moreInfoBtn}
          data-testid="loyalty-program-tiers-info-btn"
          onClick={onClickMoreInfo}
        >
          {t('loyaltyProgramTutorial.moreInfo')}
        </Button>
      </Tooltip>
    </Overlay>
  );
};

export default TutorialVipClubStatus;
